import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  allClass: 'wt60',
  classArr: [],
  minHeight: 1,
  speed: 200,
  dots: false,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  // useTransform: true,
  // rtl: true,
  variableWidth: true,
  // centerMode: true,
  responsive: [{
    breakpoint: 1366,
    settings: {
      dots: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
    },
  }, {
    breakpoint: 1200,
    settings: {
      dots: true,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      // variableWidth: false,
    },
  }, {
    breakpoint: 640,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      // centerPadding: '15px',
      // variableWidth: true,
    },
  }],
};

function NewNews(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.build();
  this.update();
  this.ready();
}

NewNews.prototype = {
  build() {
    return this.$element.find('.view-content').slick(this.settings);
  },
  update() {
    const elements = this.$element;
    const elementWidth = elements.width();
    const windowWidth = $(window).width();
    elements.find('.slick-slide').each(function () {
      if (windowWidth > 1366) {
        $(this).width(Math.ceil(elementWidth / 4 - 30));
      } else if (windowWidth > 1200) {
        $(this).width(Math.ceil(elementWidth / 3 - 30));
      } else if (windowWidth > 640) {
        $(this).width(Math.ceil(elementWidth / 2 - 30));
      } else {
        $(this).width(elementWidth - 30);
      }
      // console.log($(this).width());
    });
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default NewNews;
